import { FitBoundsOptions, LngLatBoundsLike } from 'mapbox-gl'

import { ItemData } from 'src/context/results/types'
import { TSearchType } from 'src/shared/types'
import { PinData } from './types'

export const getBounds = (
  pins: { lat: number; long: number }[],
  fitBoundsOptions: FitBoundsOptions = {
    padding: {
      left: 100,
      top: 100,
      right: 100,
      bottom: 100,
    },
    maxZoom: 14,
  }
): {
  bounds: LngLatBoundsLike
  fitBoundsOptions: FitBoundsOptions
} => {
  if (pins.length === 0) {
    return {
      bounds: [
        [0, 0],
        [0, 0],
      ],
      fitBoundsOptions,
    }
  }

  const bottomRight = [
    Math.min(...pins.map(({ long }) => long)),
    Math.min(...pins.map(({ lat }) => lat)),
  ] as [number, number]
  const topLeft = [
    Math.max(...pins.map(({ long }) => long)),
    Math.max(...pins.map(({ lat }) => lat)),
  ] as [number, number]

  return { bounds: [topLeft, bottomRight], fitBoundsOptions }
}

export const getPracticeMarkers = (
  data: ItemData[],
  itemType: TSearchType,
  isSliceTemplate = false
): PinData[] =>
  data
    .filter(({ isVirtualCareOnly }) => !isVirtualCareOnly)
    .map(result => {
      const { address1, address2, fullAddress, phone } = result
      const popupText = [
        `${address1} ${address2 ? `, ${address2}` : ''}`,
        fullAddress,
      ]
      const pinData: PinData = {
        id: result.id,
        latitude: result.lat,
        longitude: result.long,
        title: result.practiceName,
        text: popupText,
      }

      if (itemType === 'practitioner' || isSliceTemplate) {
        pinData.text?.push(phone)
      }

      return pinData
    })
